@switch (type()) {
    @case ('clock') {
        <span class="bazis-timer__hours">05</span>
        :
        <span class="bazis-timer__minutes">05</span>
        :
        <span class="bazis-timer__seconds">00</span>

        <!-- <span id="days">00</span>д :
  <span id="hours">00</span>ч :
  <span id="minutes">00</span>м :
  <span id="seconds">00</span>с -->
    }
    @case ('circle') {
        <svg
            [style.--stroke-dashoffset]="strokeDashOffset"
            [style.--length]="lengthCircle"
            part="svg"
        >
            <!-- Фоновый круг -->
            <circle
                class="bazis-timer__background"
                part="circle bg"
            ></circle>
            <!-- Прогресс (синий круг) -->
            <circle
                #circleRef
                class="bazis-timer__progress"
                part="circle progress"
                [attr.stroke-dashoffset]="strokeDashOffset"
                [attr.stroke-dasharray]="lengthCircle"
            ></circle>
        </svg>
        <div
            class="bazis-timer__text"
            part="value"
        >
            {{ timeLeft }}
        </div>
    }
    @default {}
}
